export default function ServiceAreaStrip() {
  const cities = [
    'Warrenton', 'Astoria', 'Seaside', 'Cannon Beach', 'Tillamook',
    'Lincoln City', 'Newport', 'Florence', 'Coos Bay', 'Portland',
    'Vancouver', 'Longview', 'Kelso', 'Centralia', 'Olympia'
  ];

  return (
    <section className="bg-gradient-to-r from-teal-600 to-teal-700 py-12">
      <div className="container mx-auto px-6">
        <div className="text-center mb-8">
          <h2 className="text-3xl font-bold text-white mb-3">
            Serving the Entire Oregon Coast & SW Washington
          </h2>
          <p className="text-xl text-teal-100">
            Delivery available to all areas — we bring affordable vehicles to you
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 max-w-5xl mx-auto">
          {cities.map((city, index) => (
            <span
              key={index}
              className="bg-white/20 backdrop-blur-sm text-white px-4 py-2 rounded-full text-sm font-medium border border-white/30"
            >
              {city}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}